<template>
	<div id="appbox">
		<div class="top_heard">
			<!-- <div class="top_minemsgbox">
				<div class="top_institutionmsg">
					黑龙江省文化和旅游厅 | 黑龙江省研学实践教育协会
				</div>
				<div class="welcome">
					欢迎您访问：河南研学平台！
				</div>
				
			</div> -->
		<!-- 	<div class="Site_switch">
				<el-select v-model="Site_url" @change="Siteurl"  size="small" class="Site_switch_type" placeholder="站点选择">
				  <el-option
					v-for="item in Siteoptions"
					:key="item.value"
					:label="item.label"
					:value="item.value"
					>
				  </el-option>
				</el-select>
			</div> -->
			<div class="top_box">
				<div class="logo_box">
					<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
				</div>
				<div class="top_gatebox">
					<div class="manage_switch" v-if="screenWidth>785">
						<el-select v-model="manage_url" @change="manageurl"  size="small" class="Site_switch_type" placeholder="选择入口">
						  <el-option
						    v-for="item in manageoptions"
						    :key="item.value"
						    :label="item.label"
						    :value="item.value"
							>
						  </el-option>
						</el-select>
					</div>
				</div>
				<div class="top_search_box">
					<div class="top_search">
						<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
						  <el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value"
							
							>
						  </el-option>
						</el-select>
						<!-- <i class="el-icon-search"></i> -->
						<input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
						<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="gotopsearch()" alt="" srcset="">
					</div>
					  
				</div>
				<div class="top_right">
					<div class="top_Mobiletype" @click="goregister()">
						账号注册/绑定
					</div>
					<div class=""  v-if="token" >
						欢迎访问!
					</div>
					<div class=""  v-if="token"  style="color: darkred;margin-left: 5px;" @click="logout()" >
						登出
					</div>
				</div>
			</div>
			<div class="top_tab_box">
				<div class="toptabnav">
						<el-menu
						  :default-active="activeIndex2"
						  class="el-menu-demo"
						  mode="horizontal"
						  @select="handleSelect"
						  router
						  background-color="#1b9d57"
						  text-color="#FFFFFF"
						  active-text-color="#FFFFFF">
							<el-menu-item index="/Home"  >首页</el-menu-item>
						<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
						<el-menu-item index="/Campmap" >研学地图</el-menu-item>
						
						<el-submenu index="/institution">
						    <template slot="title">研学单位</template>
						    <el-menu-item index="/Camplist" >研学营地</el-menu-item>
						    <el-menu-item index="/Baselist" >研学基地</el-menu-item>
						    <el-menu-item index="/traveler" >研学机构</el-menu-item>
						  </el-submenu>
						
							<el-submenu index="/Courselist">
						    <template slot="title">研学产品</template>
						    <el-menu-item index="/Courselist" >研学课程</el-menu-item>
						<el-menu-item index="/Linelist" >研学线路</el-menu-item>
						  </el-submenu>
						  	<el-submenu index="/authLesson">
						    <template slot="title">认证申请</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/authLesson" >课程认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >基地认证申请</el-menu-item>
						    <el-menu-item index="/authLesson" >机构认证申请</el-menu-item>
						   
						  </el-submenu>
<!--						<el-menu-item index="/Activitylist">活动中心</el-menu-item>-->
						<el-submenu index="/Mentorlist">
						    <template slot="title">证书管理</template>
						    <!-- <el-menu-item><a href="https://admin.henanyanxue.com/_uc/index" target="_blank" style="color: #ffffff;">学生证书申请</a></el-menu-item> -->
						    <el-menu-item index="/Mentorlist" >导师证书查询</el-menu-item>
						   
						  </el-submenu>
						  
              			
						<el-menu-item index="/expertlist" >智库专家</el-menu-item>
             			<el-menu-item index="/OrgRegister" >入驻平台</el-menu-item>
						<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
					</el-menu>
				</div>
			<!-- 	<div class="top_banner">
					<el-carousel ref="carousel" :interval="4000"  height="480px">
					  <el-carousel-item v-for="item in platelist" :key="item">
						<h3 class="medium" style="width: 100%;height: 100%;"><img :src="item.thumb"  style="width: 100%;height: 100%;" alt="" srcset=""></h3>
					  </el-carousel-item>
					</el-carousel>
				</div>
				<div class="top_plate">
					<div class="plate_item" v-for="(plate, index) in platelist" :key="plate" @mouseover="showstep(index)" @click="goplate(plate.id)" >
						<div class="plate_icon">
							<img :src="plate.icon" alt="" srcset="">
						</div>
						<div class="plate_title">
							{{plate.title}}
						</div>
					</div>
				</div> -->
			</div>
		</div>
		<div class="Siteall_tab_box">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane :label="'基地营地('+camptotal+')'" name="camplist">
					<div class="camplist">
						<div class="campitems"  v-for="item in Camplist" :key="item"   >
							<div class="campitem_imgbox">
								<img :src="item.icon" alt="" srcset="">
								<div class="campitem_tags">
									<div class="campitem_tag" v-for="tag in item.tags" :key="tag" :style="'color:'+tag.color+';background:'+tag.background+';'" >
										{{tag.title}}
									</div>
								</div>
							</div>
							<div class="campitem_msg">
								<div class="campitem_msg_title">
									<span>{{item.type}}</span>{{item.title}}
								</div>
								<div class="campitem_msg_introduce">
									<i class="el-icon-office-building" style="color:#1b9d57 ;margin-right: 10px;"></i>所属单位：{{item.legal_entity}}
								</div>
								<div class="campitem_msg_introduce">
									<i class="el-icon-timer" style="color:#1b9d57 ;margin-right: 10px;"></i>开放时间：{{item.open_time}}
								</div>
								<div class="campitem_msg_introduce" v-if="item.conf.length">
									<i class="el-icon-date" style="color:#1b9d57 ;margin-right: 10px;"></i>服务设施：<el-tag style="margin:0px 5px;" size="mini" v-for="tag in item.conf" :key="tag" :color="tag.background" effect="dark" >{{tag.title}}</el-tag>
								</div>
						<!-- 		<div class="campitem_msg_introduce">
									<i class="el-icon-location-information" style="color:#1b9d57 ;margin-right: 10px;"></i>所在地址：{{item.address}}
								</div> -->
								<div class="campitem_msg_button">
									<div class="msg_button" @click="gocamp(item.id)" >
										查看详情
									</div>
								</div>
							</div>
						</div>
						<div class="pages_total">
							<el-pagination
							  background
							  :page-size="9"
							  :hide-on-single-page="true"
							  @current-change="pagechange"
							  layout="total, prev, pager, next"
							  :total="camptotal">
							</el-pagination>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane :label="'活动('+Activitytotal+')'" name="Activitylist">
					<div class="activitylist_box">
						<div class="activity_item" v-for="item in actlist" :key="item" @click="goactivity(item.id)">
							<div class="activity_img" @mouseover="showactmsg(item.id)">
								<img :src="item.icon" alt="" srcset="">
								<img src="../../../static/img/进行中.png" v-if="item.status==2" class="type_icon" alt="" srcset="">
								<img src="../../../static/img/已完成.png" v-if="false" class="type_icon" alt="" srcset="">
							</div>
							<div :class="showmsg==item.id?'activity_details activity_details_show':'activity_details activity_details_close'" @mouseleave="closeactmsg(item.id)">
								<div class="activity_details_top">
									<div class="activity_details_title">
										{{item.title}}
									</div>
									<div class="activity_msg">
										{{item.introduction||'暂无介绍'}}
									</div>
								</div>
								<div class="activity_details_bottom">
									<div class="activity_details_timer">
										<i class="el-icon-document" style="font-size: 26px;margin-right: 10px;"></i>
										{{item.start+'——'+item.end}}
									</div>
									<div class="activity_details_buttonbox">
										<div class="activity_price">
											{{'￥'+item.price}}
										</div>
										<button @click="goactivity(item.id)">查看详情</button>
									</div>
								</div>
							</div>
							<div class="activity_bottom">
								<div class="activity_title">
									{{item.title}}
								</div>
								<div class="Organizer">
									<div class="camp_img">
										<img src="../../../static/img/顶部搜素图标.png" alt="" srcset="">
									</div>
									<div class="Organizer_msg">
										<div class="Organizer_unit">
											{{item.unit}}
										</div>
										<div class="Organizer_subtitle">
											{{item.subtitle}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="pages_total">
						<el-pagination background :page-size="6" :hide-on-single-page="true" @current-change="pagechange"
							layout="total, prev, pager, next" :total="Activitytotal">
						</el-pagination>
					</div>
				</el-tab-pane>
				<el-tab-pane :label="'线路('+Linetotal+')'" name="Linelist">
					<div class="camplist">
						<div class="campitems"  v-for="item in linelist" :key="item" @click="goline(item.id)"  >
							<div class="campitem_imgbox">
								<img :src="item.icon" alt="" srcset="">
							
							</div>
							<div class="campitem_msg">
								<div class="campitem_msg_title">
									<!-- <span>{{item.type}}</span> -->
									<i class="el-icon-guide" style="color:#1b9d57 ;margin-right: 10px;"></i>
									{{item.title}}
								</div>
								<div class="lineitem_msg_introduce">
									<div class="campitem_tags">
							<!-- 			<div class="campitem_tag" v-for="tag in item.lesson" :key="tag" :style="'color:'+tag.color+';background:'+tag.background+';'" >
											{{tag.title}}
										</div> -->
										<i class="el-icon-medal" style="color:#1b9d57 ;margin-right: 10px;"></i>
										路线成分：
										  <el-tag
										    v-for="tag in item.lesson"
											size="small"
										    :key="tag"
											:color="tag.color"
											style="margin-right: 5px;"
										    effect="dark">
										    {{tag.title}}
										  </el-tag>
									</div>
								
									<div class="introduce">
										<i class="el-icon-office-building" style="color:#1b9d57 ;margin-right: 10px;"></i>发起单位：{{item.unit}}
									</div>
									<div class="campitem_tags">
									<!-- 			<div class="campitem_tag" v-for="tag in item.lesson" :key="tag" :style="'color:'+tag.color+';background:'+tag.background+';'" >
													{{tag.title}}
												</div> -->
												<i class="el-icon-medal" style="color:#1b9d57 ;margin-right: 10px;"></i>
												适用学段：
												  <el-tag
												    v-for="tag in item.periods"
													size="small"
												    :key="tag"
													:color="tag.color"
													style="margin-right: 5px;"
												    effect="dark">
												    {{tag.title}}
												  </el-tag>
											</div>
									<div class="introduce">
										<i class="el-icon-reading" style="color:#1b9d57 ;margin-right: 10px;"></i>路线课程：{{item.lesson_nums}}节
									</div>
								</div>
								<div class="lineitem_msg_button">
									<div class="msg_button" >
										查看详情
									</div>
								</div>
							</div>
						</div>
						<div class="pages_total">
							<el-pagination
							  background
							  :page-size="9"
							  :hide-on-single-page="true"
							  @current-change="pagechange"
							  layout="total, prev, pager, next"
							  :total="Linetotal">
							</el-pagination>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane :label="'课程('+Coursetotal+')'" name="Courselist">
					<div class="course_box">
						<div class="coures_item" v-for="item in lessonlist" :key="item"  @click="golesson(item.id)"  >
							<div class="coures_item_icon">
								<img :src="item.icon" alt="" srcset="">
								<div class="coures_item_type">
									<span v-for="tags in item.camp_lcategory" :key="tags" :style="'background-color:'+tags.color+';'">{{tags.title}}</span>
								</div>
							</div>
							<div class="coures_item_title">
								{{item.title}}
							</div>
							<div class="coures_item_msg">
								课程时间：<span style="color: #1b9d57;">{{item.research_class}}</span>课时
							</div>
							<div class="coures_item_tags">
								<div class="campitem_tag" v-for="tag in item.periods_data" :key="tag" :style="'color:'+tag.color+';background:'+tag.background+';'" >
									{{tag.title}}
								</div>
							</div>
						</div>
						<div class="course_pages_total">
							<el-pagination
							  background
							  :page-size="9"
							  :hide-on-single-page="true"
							  @current-change="pagechange"
							  layout="total, prev, pager, next"
							  :total="Coursetotal">
							</el-pagination>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane :label="'机构('+travelertotal+')'" name="travelerlist">
					<div class="camplist">
						<div class="campitems"  v-for="item in Travelerlist" :key="item"   >
							<div class="campitem_imgbox">
								<img :src="item.icon" alt="" srcset="">
								<div class="campitem_tags">
									<div class="campitem_tag" v-for="tag in item.tags" :key="tag" :style="'color:'+tag.color+';background:'+tag.background+';'" >
										{{tag.title}}
									</div>
								</div>
							</div>
							<div class="campitem_msg">
								<div class="campitem_msg_title">
									{{item.title}}
								</div>
								<div class="campitem_msg_introduce">
									<i class="el-icon-location-information" style="color:#1b9d57 ;margin-right: 10px;"></i>所在地址：{{item.address}}
								</div>
								<div class="campitem_msg_button">
									<div class="msg_button" @click="goTraveler(item.id)" >
										查看详情
									</div>
								</div>
							</div>
						</div>
						<div class="pages_total">
							<el-pagination
							  background
							  :page-size="9"
							  :hide-on-single-page="true"
							  @current-change="pagechange"
							  layout="total, prev, pager, next"
							  :total="travelertotal">
							</el-pagination>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane :label="'资讯资讯('+newstotal+')'" name="newslist">
					<div class="newsall_box">
						<div class="newsitem" v-for="item in newslist" :key="item"  @click="gonews(item.id)" >
							<div class="newsimg">
								<img :src="item.icon" alt="" srcset="">
							</div>
							<div class="newsmsg">
								<div class="newstitle" style="-webkit-box-orient:vertical;">
									{{item.title}}
								</div>
								<div class="author">
									  <el-tag
									    type="warning"
									    effect="plain"
										size="medium ">
									   {{item.author||'未知'}}
									  </el-tag>
								</div>
								<div class="news_bottom">
									<div class="newstime">
										{{item.update_time}}
									</div>
									<div class="pageview">
										<i class="el-icon-view"></i>
										{{item.looks}}
									</div>
								</div>
							</div>
						</div>
						<div class="pages_total">
							<el-pagination
							  background
							  :page-size="9"
							  :hide-on-single-page="true"
							  @current-change="pagechange"
							  layout="total, prev, pager, next"
							  :total="newstotal">
							</el-pagination>
						</div>
					</div>
					
				</el-tab-pane>
				<el-tab-pane :label="'指导师('+mentortotal+')'" name="mentorlist">
					<div class="column2_box">
						<div class="mentor_item"   v-for="item in mentorlist" :key="item">
							<div class="mentor_imgs">
								<img :src="item.icon" alt="" srcset="">
							</div>
							<div class="mentor_msgbox">
								<div class="mentor_title">
									{{item.title}}
								</div>
								<div class="mentor_subtitle">
									{{item.titles}}
								</div>
								<div class="mentor_msg">
									指导师级别:{{item.titles}}
								</div>
								<div class="mentor_msg">
									备案编号:{{item.zsbh}}
								</div>
								<!-- <div class="mentor_msg">
									发证日期:{{item.fzs_time}}
								</div>
								<div class="mentor_msg">
									所在机构:{{item.campname}}
								</div> -->
							</div>
						</div>
						<div class="course_pages_total" style="margin-bottom: 30px;">
							<el-pagination
							  background
							  :page-size="12"
							  :hide-on-single-page="true"
							  @current-change="pagechange"
							  layout="total, prev, pager, next"
							  :total="mentortotal">
							</el-pagination>
						</div>
					</div>
					
				</el-tab-pane>
				<el-tab-pane :label="'专家('+experttotal+')'" name="expertlist">
					<div class="column2_box">
						<div class="mentor_item"   v-for="item in expertlist" :key="item" @click="goexpert(item.id)">
							<div class="mentor_imgs">
								<img :src="item.icon" alt="" srcset="">
							</div>
							<div class="mentor_msgbox">
								<div class="mentor_title">
									{{item.title}}
								</div>
								<div class="expert_subtitle">
									{{item.description}}
								</div>
							</div>
						</div>
						<div class="course_pages_total">
							<el-pagination
							  background
							  :page-size="12"
							  :hide-on-single-page="true"
							  @current-change="pagechange"
							  layout="total, prev, pager, next"
							  :total="experttotal">
							</el-pagination>
						</div>
					</div>
					
				</el-tab-pane>
			</el-tabs>
			
		</div>
		
		<div :class="tops?'navbar':'navbar-top'" style="top: 68%;">
			 <div  class="qrShow3 right2" style="top: calc(68% - 30px);"  v-if="showofficialQR">
				<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
			 </div>
			 <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showofficialQRCode" @mouseleave="hideofficialQRCode"><i class="el-icon-s-help"></i>  
						
				 <div style="font-size: 14px;">公众号</div></a>
			 <div  class="qrShow2 right2" style="top: calc(68% + 30px);;"  v-if="showserviceQR">
				<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
			 </div>
			 <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
						
				 <div style="font-size: 14px;">客服</div></a>
			 <div  class="qrShow right" style="top: calc(68% + 90px);;" v-if="showQR">
				<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
			 </div>
			 <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showQRCode" @mouseleave="hideQRCode"><i class="el-icon-mobile-phone"></i> 
					
				 <div style="font-size: 14px;">手机端</div></a>
			 <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
				 <a @click="gotop"><i class="el-icon-caret-top"></i>
				 <br>
				 <span>顶部</span></a>
			 </el-tooltip>
		</div>
		<div class="pagesbottom_box"  :style="screenWidth>785?'':'width:100%;'" >
			<div class="subtexts" v-if="screenWidth>785" >
				<div v-for="(item, key) in bottomnav" :key="key" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
			</div>
			<div class="subnavbox" v-if="screenWidth<785" >
				<div class="subtext_title">
					关于研学平台
				</div>
				<div class="subtexts" :style="screenWidth>785?'':'width:calc(100% - 40px);flex-wrap:wrap;padding:20px;margin-top: 0px;'" >
					<div v-for="(item, key) in bottomnav" :key="key" :style="screenWidth>785?'':'width:25%;text-align: left;margin-bottom:15px'"  @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
			</div>
		<div class="footer_box">
			<div class="row"  :style="screenWidth>785?'padding-bottom:0px':'width:calc(100% - 20px);padding:0px 10px;padding-bottom:0px'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						指导单位：河南省教育厅   主办单位：河南省研学旅行教育协会
					</div>
				</div>
				
			</div>
			<div class="row"  :style="screenWidth>785?'':'width:calc(100% - 20px);padding:0px 10px;'">
				
				<div class="copy-left" :style="screenWidth>785?'':'width:40%;'">
				</div>
				
				<div class="bottom_right" :style="screenWidth>785?'':'margin-left:10px;'">
					<div class="bottom_msg">
						{{pcsetdata.foot}}
					</div>
					<div class="bottom_msg">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
					</div>
					<div class="bottom_msg">
						课程适用人群:学生群体
					</div>
				</div>
				
			</div>
		</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapMutations } from 'vuex'
	import { getPc,getbottomnav, getLinelist,getTeacher,getCourselist,getNewslist,getexpert,getCamplist,getAclist,getTraveler} from '@/request/api'
	import { Loading } from 'element-ui';
	// import navTab from '../Navtab/navtab'
	let _this=null
	export default {
	  name: "Siteall",
	    // components: {
	    //   navTab
	    // },
	  data(){
		  return {
				top_search_url:'/Siteall',
				manage_url:'',
				manageoptions:[
					{
					  value: 'http://qianjin.wanjiaxiao.cn/',
					  label: '研学报备'
					}, {
					  value: 'https://admin.henanyanxue.com/',
					  label: '管理入口'
					},
					
				],
				modules:'',
				activeIndex2: '/Siteall',
				platelist:[],
				phoneboxshow:false,
				activeName:'camplist',
				userInfo: {
				  username: "",
				  education_name: "",
				  role_level: ""
				},
				stitle:'',
				Site_url: 'http://yxpc.wanjiaxiao.cn/#/',
				Siteoptions:[
					{
					  value: 'http://yxpc.wanjiaxiao.cn/#/',
					  label: '研学总站'
					}, {
					  value: 'http://mishan.wanjiaxiao.net/#/',
					  label: '密山研学'
					}, 
				],
				newscategory_id:0,
				logintype:true,
				//专家列表
				experttotal:0,
				expertlist:[],
				//指导师列表
				mentorlist:[],
				mentortotal:0,
				//资讯列表
				newstotal:0,
				newslist:[],
				//机构
				travelertotal:0,
				Travelerlist:[],
				//课程列表
				lessonlist:[],
				Coursetotal:0,
				//线路列表
				linelist:[],
				Linetotal:0,
				//活动列表
				actlist:[],
				Activitytotal:0,
				showmsg:'',
				//基地营地列表
				Camplist:[],
				camptotal:0,
				//页数控制
				page_index:1,
				//搜索栏选项
				options: [
						{
							value: '/Siteall',
							label: '全站搜索'
						},
						{
				          value: '/Camplist',
				          label: '营地搜索'
				        }, {
				          value: '/Baselist',
				          label: '基地搜索'
				        }, {
				          value: '/Courselist',
				          label: '课程搜索'
				        },{
				          value: '/Newslist',
				          label: '资讯搜索'
				        },
						{
						  value: '/Activitylist',
						  label: '活动搜索'
						},
						{
						  value: '/Linelist',
						  label: '线路搜索'
						},
						{
						  value: '/traveler',
						  label: '机构搜索'
						},{
						  value: '/mentorlist',
						  label: '指导师搜索'
						},],
				//底部导航
				bottomnav:[],
				//侧边栏
				 showQR:false,
				  showserviceQR:false,
				  showofficialQR:false,
				tops:false,
				heights:window.innerHeight,
				scrolltop:'',
		      }
	  },
	  beforeCreate(){
		   const loading = this.$loading({
				lock: true,
				text: '页面载入……',
				// spinner: 'el-icon-loading',
				background: '#ffffff'
			  });
	  },
	  created() {
		  _this =this
		  this.getpcset()
	  },
	  mounted() {
		  const { stitle } = this.$route.query;
		  this.stitle = stitle||''
		this._getCamplist()
		this._getAclist()
		this._getlinelist()
		this.getlessonlist()
		this.getTraveler()
		this._getNewslist()
		this.getmentor()
		this.getexpert()	
		this.getbottomnav()
		
		var token = localStorage.getItem('token')||''
		this.token=token
		// this.getlessonlist()
	  window.addEventListener('scroll', this.scrollToTop)
	  		
	  },
	   destroyed () {
	          window.removeEventListener('scroll', this.scrollToTop)
	    },
	  beforeDestroy(){
		
	  },
	  methods: {
		  manageurl(e){
		  		  console.log('Site',e)
		  		  if(e!='/'){
		  			   window.open(e) 
		  		  }
		  		//this.manage_url='/'
		  		  // window.location.href = e;
		  		  
		  },
		  // tab切换
		  handleClick(e){
			console.log(e.name,this.activeName)
			this.page_index=1
			if(e.name=='camplist'){
				this._getCamplist()
			}
			if(e.name=='Activitylist'){
				this._getAclist()
			}
			if(e.name=='Linelist'){
				this._getlinelist()
			}
			if(e.name=='Courselist'){
				this.getlessonlist()
			}
			if(e.name=='travelerlist'){
				this.getTraveler()
			}
			if(e.name=='newslist'){
				this._getNewslist()
			}
			if(e.name=='mentorlist'){
				this.getmentor()
			}
			if(e.name=='expertlist'){
				this.getexpert()			  
			}
		  },
		  //翻页
		  pagechange(val){
			  this.page_index=val
			  if(this.activeName=='camplist'){
			  	this._getCamplist()
			  }
			  if(this.activeName=='Activitylist'){
			  	this._getAclist()
			  }
			  if(this.activeName=='Linelist'){
			  	this._getlinelist()
			  }
			  if(this.activeName=='Courselist'){
			  	this.getlessonlist()
			  }
			  if(this.activeName=='travelerlist'){
			  	this.getTraveler()
			  }
			  if(this.activeName=='newslist'){
			  	this._getNewslist()
			  }
			  if(this.activeName=='mentorlist'){
			  	this.getmentor()
			  }
			  if(this.activeName=='expertlist'){
				this.getexpert()
			  }
		  },
		  Siteurl(e){//切换站点
		  		console.log('Site',e)  
		  		window.location.href = e;
		  },
		  logout(){//退出登录
		  			  var that=this
		  			  this.$confirm('是否确认退出登录?', '提示', {
		  			  					confirmButtonText: '确定',
		  			  					cancelButtonText: '取消',
		  			  					type: 'warning'
		  			  }).then(() => {
		  						this.$alert("已退出登录", '', {
		  							confirmButtonText: '确认',
		  							callback: action => {
		  								localStorage.setItem('token', '')
		  								localStorage.setItem('refreshToken', '')
		  								 that.$router.go(0)
		  							}
		  						  });
		  			  }).catch(() => {
		  			  		 
		  			  });
		  },
		  showQRCode(){//显示二维码
		          this.showQR = true
		      },
		      hideQRCode(){//隐藏二维码
		          this.showQR = false
		      },
		      scrollToTop () {//侧边栏返回顶部相关
		          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		          this.scrolltop = scrollTop
		          if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
		              this.tops = true
		          } else {
		              this.tops = false
		          }
		      },
		      gotop () {//返回顶部
		          let timer = setInterval(() => {
		              document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
		              if (this.scrolltop === 0) {
		                  clearInterval(timer)
		              }
		          }, 15)
		      },
		  getbottomnav(){//获取底部导航
			  var data={
				  page_index:1,
				  page_size:15
			  }
			getbottomnav(data).then(res=>{
				this.bottomnav=res.data.data.list
			})  
		  },
		  gobottomnav(type,link){//底部导航跳转
			  if(type==1){
				  this.$router.push({
				  	path:link
				  });
			  }else if(type==2){
			  window.location.href = link;
		  }
		  },
		  goexpertlist(){//跳转专家列表
			  this.$router.push({
			  	path:'/expertlist',
			  	name:'/expertlist',
			  	query: {
			  	}
			  });
		  },
		  goexpert(id){//跳转专家详情
			  this.$router.push({
			  	path:'/expertdetails',
			  	name:'expertdetails',
			  	query: {
			  		id: id
			  	}
			  });
		  },
		  camptypego(id){//跳转营地列表
			  console.log(id)
			  this.$router.push({
			    path: '/Camplist',
			    name: "/Camplist",
			    query: {
			      region_type: id,
			    }
			  });
		  },
		  gocolumn(url){//查看更多的跳转
			  this.$router.push({
			    path: url,
			    name: url,
			    query: {
			    }
			  }); 
		  },
		  gotopsearch(){//搜索点击
			if(this.top_search_url=='/Siteall'){
				this._getCamplist()
				this._getAclist()
				this._getlinelist()
				this.getlessonlist()
				this.getTraveler()
				this._getNewslist()
				this.getmentor()
				this.getexpert()	
				return
			}
			  this.$router.push({
			    path: this.top_search_url,
			    name: this.top_search_url,
			    query: {
			      stitle: this.stitle,
			    }
			  }); 
		  },
		  goTraveler(id){//跳转研学机构详情
			 this.$router.push({
			   path: "/travelerdetails",
			   name: "travelerdetails",
			   query: {
			     id: id
			   }
			 }); 
		  },
		  gomentor(){//跳转指导师列表
			  this.$router.push({
			    path: "/mentorlist",
			    name: "/mentorlist",
			  		  query: {
			  		  }
			  });
		  },
		  goTravelerlist(){//跳转研学机构列表
			  this.$router.push({
			    path: "/traveler",
			    name: "/traveler",
			  		  query: {
			  		  }
			  });
		  },
		  getTraveler(){//获取研学机构
			  var data={
			  	isshow:1,
				page_index:this.page_index,
				page_size:9,
				title:this.stitle,
			  }  
			  getTraveler(data).then(res=>{
				  this.Travelerlist=res.data.data.list
				  this.travelertotal=res.data.data.total
			  	// this.platelist=res.data.data
			  })
		  },
		  showofficialQRCode(){
			 this.showofficialQR=true
		  },
		  hideofficialQRCode(){//隐藏二维码
		      this.showofficialQR = false
		  },
		  showserviceQRCode(){
		  			  this.showserviceQR=true
		  },
		  hideserviceQRCode(){//隐藏二维码
		      this.showserviceQR = false
		  },
		  showphonebox(){
			this.phoneboxshow=true  
		  },
		  closephonebox(){
			this.phoneboxshow=false  
		  },
		  goregister(e){//去注册页面
			this.$router.push({
			path: "/register",
			name: "/register",
				  query: {
				  }
			});
		  },
		showstep(ind) {//改变板块当前显示轮播图
		        this.$refs.carousel.setActiveItem(ind)
		  },
		  _getlinelist(){//获取线路列表
			  var data={
				  page_index:this.page_index,
				  page_size: 9,
				  is_pc:1,
				  title:this.stitle,
			  }
			  getLinelist(data).then(res=>{
			  	console.log(res.data)
			  	this.linelist=res.data.data.list
				this.Linetotal=res.data.data.total
			  	// this.quicklist=res.data.data.list
			  }).catch(error => {
			  	console.error(error);
			  });
		  },
		  changementor(e){
			console.log('1112',e)  
			this.mentorindex=e+1
			this.getmentor()
		  },
		  mentoropen(index){
			this.mentor_index=index  
		  },
		  relist(data){
			  const list = data.split(',');
			  return list
		  },
		  getmentor(){//获取指导师列表
			  var data={
				  page_index:this.page_index,
				  page_size:12,
				  search:this.stitle,
			  }
			  getTeacher(data).then(res=>{
				  this.mentorlist=res.data.data.list
				  this.mentortotal=res.data.data.total
			  })
		  },
		  getNt(){//获取公告
			// getNt().then(res=>{
			// 	this.ntlist=res.data.data
			// })  
		  },
		  getpcset(){//获取pc端信息
			getPc().then(res=>{
				this.pcsetdata=res.data.data
			})  
		  },
		  golesson(e) {//去课程详情
		    this.$router.push({
		      path: "/CourseDetails",
		      name: "CourseDetails",
		      query: {
		        id: e
		      }
		    });
		  },
		  camptypetab(val){
			// this.lessoncategory_id=val
			this.getlessonlist()
		  },
		  getlessontypes(){//获取课程类型
		  			// var data={}
		  			// getPac(data).then(res=>{
		  			// 	console.log(res.data)
		  			// 	this.categorytypes=res.data.data.cat
		  			// 	// this.periodtypes=res.data.data.res
		  			// 	// this.lessoncategory_id=res.data.data.cat[0].id
		  			// 	this.getlessonlist()
		  			// }).catch(error => {
		  			//   console.error(error);
		  			// });
		  },
		  getlessonlist(){//获取课程列表
			var data={
				// type:this.camptype,
				page_index: this.page_index,
				page_size: 9,
				search:this.stitle,
			}  
			getCourselist(data).then(res=>{
				console.log(res.data)
				this.lessonlist=res.data.data.list
				this.Coursetotal=res.data.data.total
				const loading = this.$loading({
						 lock: true,
						 text: 'Loading',
						 spinner: 'el-icon-loading',
						 background: 'rgba(0, 0, 0, 0.7)'
					   });
				loading.close();
				// this.total=res.data.data.total
				// this.quicklist=res.data.data.list
			}).catch(error => {
				console.error(error);
			});
		  },
		  newshandleClick(e){
				console.log(e,this.category_id)
				this._getNewslist()
		  },
		  getnewstypes(){//获取资讯分类
			 //  var data={}
			 //  getCategory(data).then(res=>{
				// 	  console.log(res.data)
				// 	  this.newstypes=res.data.data
				// 	  this.newscategory_id=res.data.data[0].id
				// 	  this._getNewslist()
				// }).catch(error => {
				//   console.error(error);
				// });
		  },
		  _getNewslist(){//获取资讯列表
			  var data={
				page_index:this.page_index,
				page_size:9,
				title:this.stitle,
			  }
			getNewslist(data).then(res=>{
				console.log(res.data)
				this.newslist=res.data.data.list
				this.newstotal=res.data.data.total
			  }).catch(error => {
				  console.error(error);
				});
		  },
		  getexpert(){//获取专家列表
			  var data={
				page_index:this.page_index,
				page_size:12,
				search:this.stitle,
				type:1,
			  }
			  getexpert(data).then(res=>{
			  				  console.log(res.data)
			  				  this.expertlist=res.data.data.list
							  this.experttotal=res.data.data.total
			  }).catch(error => {
			  				  console.error(error);
			  			});
		  },
		  getinnovate(){//获取创新人才列表
		  		  var data={
		  			page_index:1,
		  			page_size:3,
		  			modules:this.modules,
		  			type:2,
		  		  }
		  		  getexpert(data).then(res=>{
		  		  				  console.log(res.data)
		  		  				  this.innovatelist=res.data.data.list
		  						  // if(this.expertlist.length<8){
		  							 //  this.swiperexpert.autoplay=false
		  						  // }
		  		  }).catch(error => {
		  		  				  console.error(error);
		  		  			});
		  },
		  _getCamplist(){//获取基地营地列表
			  var data={
				  page_index:this.page_index,
				  page_size:9,
				  title:this.stitle,
			  }
			  const loading = this.$loading({
			           lock: true,
			           text: '页面载入……',
			           // spinner: 'el-icon-loading',
			           background: '#ffffff'
			         });
			  getCamplist(data).then(res=>{
					  console.log(res.data)
					  this.Camplist=res.data.data.list
					  this.camptotal=res.data.data.total
					   loading.close();
			  }).catch(error => {
				   loading.close();
				  console.error(error);
				});
		  },
		  showactmsg(id) {//活动详情展示
		  	this.showmsg = id
		  },
		  _getAclist(){//获取活动列表
			  var data={
				  page_index:this.page_index,
				  page_size:6,
				  title:this.stitle,
			  }
			  getAclist(data).then(res=>{
			  			  console.log(res.data)
						  this.actlist=res.data.data.list
						  this.Activitytotal=res.data.data.total
			  			  // this.banner=res.data.data
			  }).catch(error => {
					  console.error(error);
				});
		  },
		handleSelect(key, keyPath) {
			console.log(key, keyPath);
		},
		gontdetails(e){//去公告详情
			this.$router.push({
			  path: "/Ntdetails",
			  name: "Ntdetails",
			  query: {
			    id: e
			  }
			});
		},
	    gonews(e){//去资讯详情
			this.$router.push({
			  path: "/NewsDetails",
			  name: "NewsDetails",
			  query: {
			    id: e
			  }
			});
		},
		gocamp(e){//基地营地详情
			console.log(e)
			this.$router.push({
			  path: "/CampDetails",
			  name: "CampDetails",
			  query: {
			    id: e,
			  }
			});
		},
		goline(e){//去线路详情
			this.$router.push({
			  path: "/LineDetails",
			  name: "LineDetails",
			  query: {
			    id: e
			  }
			});
		},
		goactivity(e){//去活动详情
			this.$router.push({
			  path: "/Activitydetails",
			  name: "Activitydetails",
			  query: {
			    id: e
			  }
			});
		},
	  }
	};
</script>
<style scoped>
	/* 指导师列表 */
	.expert_subtitle{
		text-indent:2rem;
		font-size: 14px;
		color: #909399;
		margin: 10px 0px;
		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 5;
		-webkit-box-orient: vertical;
		    /* min-height: 48px; */
		
	}
	.column2_box{
		width:calc(100% - 40px) ;
		padding: 20px;
		background: #ffffff;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: flex-end;
	}
	
	.mentor_item{
		padding: 20px;
		width: 330px;
		display: flex;
		align-items: center;
		background: #f9f9f9;
		border-radius: 8px;
		margin-bottom: 30px;
	}
	.mentor_imgs{
		width:100px !important;
		height: 135px;
	}
	.mentor_imgs img{
		border-radius: 5px;
		width: 100%;
		height: 100%;
	}
		
	.mentor_msgbox{
		margin-left: 20px;
		flex: 1;
		max-width: 210px;
		display: flex;
		flex-direction: column;
		
	}
	.mentor_title{
		font-size: 18px;
		font-weight: 600;
		color: #303133;
		text-align: left;
	}
	.mentor_subtitle{
		font-size: 15px;
		color: #909399;
		margin: 10px 0px;
		text-align: left;
	}
	.mentor_msg{
		font-size: 12px;
		color: #909399;
		margin: 1px;
		text-align: left;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		
	}
</style>
<style scoped>
	/* 资讯列表 */
	.newsall_box{
		width: calc(100% - 80px);
		padding: 0px 40px;
		background: #ffffff;
		padding-bottom: 40px;
	}
	.newsitem{
		width: 100% !important;
		margin: 0px !important;
	}
	.newsmsg{
		width: calc(100% - 280px) !important;
	}
</style>
<style scoped>
	.course_pages_total{
		width: 100%;
		display: flex;
		justify-content: center;
	}
	/* 课程列表 */
	.course_box{
		display: flex ;
		flex-wrap: wrap;
		width: 100%;
		margin-top: 20px;
		justify-content: space-between;
	}
	.coures_item{
		width: 340px;
		min-height: 314px;
		margin: 0px 0px 24px 0;
		border-radius: 4px;
		background: #ffffff;
		
	}
	.coures_item:hover{
		box-shadow: 0 3px 20px rgba(0,200,169,.8);
	}
	.coures_item_icon{
		position: relative;
		height: 237px;
		overflow: hidden;
	}
	.coures_item_icon img{
		width: 100%;
		height: 100%;
		-webkit-transform: scale(1);
		transform: scale(1);
		-webkit-transition: all .3s;
		transition: all .3s;
		padding: 8px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		border-radius: 12px;
/* 		-o-object-fit: scale-down;
		object-fit: scale-down; */
	}
	.coures_item_type{
		position: absolute;
		display: flex;
		justify-content: flex-end;
		flex-wrap: wrap-reverse;
		right: 0;
		z-index: 11;
		bottom: 0;
		margin: 0 3px 3px 0;
	}
	.coures_item_type span{
		display: block;
		filter: alpha(opacity=90);
		margin: 0 5px 5px 0;
		color: #fff;
		font-size: 12px;
		padding: 2px 10px;
	}
	.coures_item_title{
		font-size: 17px;
		min-height: 46px;
		height: 46px;
		width: 324px;
		padding: 8px;
		color: #333;
		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
	}
	.coures_item_msg{
		padding: 0px 8px;
		text-align: left;
		color: #999;
		    font-size: 14px;
	}
	.coures_item_tags{
		display: flex;
		/* width: 100%; */
		padding: 8px;
		justify-content: flex-end;
		
	}
	.campitem_tag{
		width: 70px;
		height: 30px;
		/* margin: 5px; */
		font-size: 12px;
		line-height: 30px;
	}
	
</style>
<style scoped>
	.lineitem_msg_introduce{
		padding-top: 15px;
		overflow: hidden;
		text-align: left;
		line-height: 26px;
		font-size: 14px;
	}
	.introduce{
		display: flex;
		align-items: center;
	}
	.lineitem_msg_button{
		    height: 42px;
		    /* margin-top: 15px; */
		    display: flex;
		    justify-content: flex-end;
	}
	.lineitem_msg_button>.msg_button{
		    z-index: 1;
		    width: 134px;
		    height: 34px;
		    background: #1b9d57;
		    color: #fff;
		    line-height: 34px;
		    text-align: center;
		    border-radius: 4px;
	}
</style>
<style scoped>
	/* 活动列表 */
	.activitylist_box {
		width: 1100px;
		margin:0px 40px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-top: 20px;
		/* align-items: ; */
	}

	.activity_item {
		width: 520px;
		height: 452px;
		overflow: hidden;
		margin-bottom: 20px;
		position: relative;
	}

	.activity_img:hover+.activity_details {}

	.activity_details_show {
		display: block !important;
		/* 鼠标悬浮时显示盒子*/
		animation: slide-in 1.5s 1;
		/* 播放向右滑动的动画 */
		animation-fill-mode: forwards;
	}

	.activity_details_close {
		animation: slide-off 1s 1;
		/* 播放向右滑动的动画 */
		animation-fill-mode: forwards;
	}

	@keyframes slide-in {
		100% {
			transform: translate(0, 0);
			/* 滑动到目标位置 */
		}
	}

	@keyframes slide-off {
		0% {
			transform: translate(0, 0);
		}

		100% {
			transform: translate(-100%, 0%);
		}
	}

	.activity_img {
		width: 520px;
		height: 312px;
		position: relative;
	}

	.activity_img img {
		width: 100%;
		height: 100%;
	}

	.type_icon {
		width: 65px !important;
		height: 65px !important;
		position: absolute;
		top: -3px;
		left: -3px;
	}

	.activity_details {
		width: 460px;
		height: 272px;
		position: absolute;
		top: 0;
		/* 相对于父元素垂直居中 */
		left: 0;
		/* 左侧距离为0 */
		transform: translate(-100%, 0%);
		/* 水平向左移动一个盒子宽度的距离 */
		padding: 20px 30px;
		background: #1b9d57e6;
		cursor: pointer;
	}

	.activity_details:hover {
		display: block !important;
		/* 隐藏盒子 */
	}

	.activity_details_top {
		width: 100%;
		height: 180px;
		border-bottom: 1px solid white;
		overflow: hidden;
	}

	.activity_details_title {
		width: 100%;
		text-align: left;
		min-height: 36px;
		line-height: 36px;
		overflow: hidden;
		font-family: "微软雅黑";
		font-size: 20px;
		font-weight: 700;
		color: white;
	}

	.activity_msg {
		width: 100%;
		height: 124px;
		text-align: left;
		margin-top: 10px;
		overflow: hidden;
		line-height: 30px;
		font-family: "微软雅黑";
		font-size: 16px;
		color: white;
	}

	.activity_details_bottom {
		width: 100%;
		height: 72px;
		padding-top: 10px;
	}

	.activity_details_timer {
		display: flex;
		align-items: center;
		width: 100%;
		/* height: 36px; */
		position: relative;
		margin-bottom: 20px;
		/* line-height: 36px; */
		margin-left: 12px;
		font-family: "微软雅黑";
		font-size: 16px;
		color: white;
	}

	.activity_details_buttonbox {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 36px;
		position: relative;
		margin-bottom: 20px;

	}

	.activity_price {
		line-height: 44px;
		font-family: "微软雅黑";
		font-size: 24px;
		color: white;
		margin-right: 8px;

	}

	.activity_details_buttonbox button {
		width: 120px;
		background: white;
		line-height: 38px;
		height: 40px;
		text-align: center;
		border-radius: 2px;
		font-family: "微软雅黑";
		font-size: 18px;
		color: #1b9d57;
		border: 1px solid #1b9d57;
	}


	.activity_bottom {
		width: 460px;
		height: 100px;
		padding: 20px 30px;
		background: #ffffff;
		overflow: hidden;
	}

	.activity_title {
		width: 100%;
		text-align: left;
		font-family: "微软雅黑";
		font-size: 20px;
		font-weight: 700;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
		color: #606266;
		margin-bottom: 10px;

	}

	.Organizer {
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.camp_img {
		width: 60px;
		height: 60px;
	}

	.camp_img img {
		width: 100%;
		height: 100%;
		border-radius: 999px;
	}

	.Organizer_msg {
		width: 384px;
		height: 60px;

	}

	.Organizer_unit {
		width: 100%;
		text-align: left;
		font-family: "微软雅黑";
		font-size: 18px;
		font-weight: 400;
		color: #303133;
		height: 30px;
		line-height: 30px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.Organizer_subtitle {
		width: 100%;
		text-align: left;
		font-family: "微软雅黑";
		font-size: 16px;
		font-weight: 400;
		color: #909399;
		height: 30px;
		line-height: 30px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.next {
		text-align: left;
		color: #1b9d57;
	}

	.newslist_box {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}

	.newslist {
		width: 790px;
		background: #fff;
		margin: 20px;
		margin-left: 0px;
		padding: 10px;
	}

	.textmsg {
		width: 388px;
		padding-top: 12px;
		/* height: 78px; */
		font-size: 16px;
		text-align: left;
		color: #818181;
		line-height: 1.6;
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
	}

	.newsitem {
		width: 720px;
		margin: 0px 10px;
		padding: 20px 0px;
		border-bottom: 1px dashed #dadada;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.newsimg {
		width: 280px;
		height: 180px;
		margin-right: 20px;
	}

	.newsimg img {
		width: 100%;
		height: 100%;
	}

	.newsmsg {
		width: 388px;
		height: 160px;
		/* padding: 20px 0px; */
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.newstitle {
		font-weight: 400;
		font-size: 24px;
		color: #333;
		/* margin-bottom: 15px; */
		text-align: left;
		/* height: 50px; */
		/* line-height: 50px; */
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.newstitle:hover {
		color: #1b9d57;
	}

	.author {
		text-align: left;
	}

	.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
		color: #1b9d57;
	}

	.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {
		color: #1b9d57;
	}

	.el-tabs__item {
		font-size: 18px;
		height: 60px;
		line-height: 60px;
		/* padding:30px ; */
	}

	.el-tabs--border-card .el-tabs__header {
		background-color: #ffffff;
	}

	.news_bottom {
		font-size: 14px;
		color: #999;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.pages_total {
		padding: 20px;
		padding-bottom: 0px;

	}

	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #1b9d57;
	}
</style>
<style scoped>
	/* 基地营地样式 */
	.el-tag--dark{
		border: 0px;
		margin:0px 2px;
	}
	.camplist{
		margin-top: 20px;
	}
	.campitems{
		margin: 0px 10px;
		margin-bottom: 20px;
		padding: 20px;
		background: #fff;
		transition: all .3s;
		-webkit-transition: all .3s;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.campitems:hover{
		box-shadow: 0 3px 20px rgba(0,200,169,.8);
	}
	.campitem_imgbox{
		position: relative;
		width: 337px;
		height: 161px;
		overflow: hidden;
	}
	.campitem_imgbox img{
		width: 100%;
		height: 100%;
	}
	.campitem_tags{
		/* position: absolute; */
	/* 	    bottom: 0;
		    right: 0; */
		    z-index: 1;
			display: flex;
			justify-content: flex-start;
			align-items:center;
	}
/* 	.campitem_tags{
		position: absolute;
		    bottom: 0;
		    right: 0;
		    z-index: 1;
			display: flex;
			justify-content: flex-end;
			align-items: flex-end;
	} */
	.campitem_tag{
		    height: 24px;
		    padding: 0 8px;
		    background: #1b9d57;
		    color: #fff;
		    line-height: 24px;
		    font-size: 12px;
			margin-left: 5px;
	}
	.campitem_msg{
		width: 750px;
		height: 161px;
		display: flex;
		flex-direction: column;
			margin-left: 10px;
		/* justify-content: ; */
		
	}
	.campitem_msg_title{
		color: #1b9d57;
		font-size: 18px;
		display: flex;
		align-items: center;
		padding: 0 10px 10px 0;
		border-bottom: 1px solid #e9e9e9;
		font-weight: 400;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		/* line-height: 24px; */
	}
	.campitem_msg_title span{
	/* 	    position: absolute;
		    top: 0;
		    left: 0; */
		    z-index: 1;
		    width: 60px;
		    height: 24px;
			line-height: 24px;
		    background: #1b9d57;
		    color: #fff;
		    font-size: 14px;
		    text-align: center;
			margin-right: 10px;
	}
/* 	.campitem_msg_introduce{
		    height: 45px;
		    padding-top: 15px;
		    overflow: hidden;
			text-align: left;
			
	} */
	.campitem_msg_introduce{
		    line-height: 30px;
			font-size: 16px;
			/* margin: 5px 0px; */
		    /* padding-top: 15px; */
			display: flex;
			align-items: center;
		    overflow: hidden;
			text-align: left;
			
	}
	.campitem_msg_button{
		height: 42px;
		    margin-top: 15px;
			display: flex;
			justify-content: flex-end;
	}
	.campitem_msg_button>.msg_button{
		    z-index: 1;
		    width: 134px;
		    height: 34px;
		    background: #1b9d57;
		    color: #fff;
		    line-height: 34px;
		    text-align: center;
		    border-radius: 4px;
	}

	
</style>
<style scoped>
	/* 总样式 */
	::v-deep .el-tabs__item.is-active{
		color: #1b9d57;
	}
	.Siteall_tab_box{
		width: 1180px;
		min-height: 600px;
		margin: 0 auto;
	}
</style> 